import {
	API_GET_ALL_VALIDATION_PAUSED_REASON,
	API_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS,
	API_GET_ALL_VALIDATION_PAUSED_REASON_FAIL,
} from '../actions/validationPausedReason';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
};

const validationPausedReasons = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_VALIDATION_PAUSED_REASON_FAIL]: (state, action) => {
		errorHandler("Motif pause validation", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default validationPausedReasons;
